export const lines = {
  2: 'h-17',
  3: 'h-23',
  4: 'h-29',
};
